export default __webpack_public_path__ + "static/media/empresa.5c295abe.png";